import React, { useContext, useEffect } from "react";
import { Col, Label, Input } from "reactstrap";
import { AnswerContext } from "../../Module/AnswerContext";

type answer = {
  node: any;
};

const QuetionRadio: React.FC<answer> = ({ node }) => {
  const { answer, setAnswerData } = useContext(AnswerContext);
  const { id } = node;
  let current_answer = 0;
  for (let a of answer) {
    if (a[0] == id) {
      current_answer = +a[1];
    }
  }

  const InputRadio = node.answerList.map((a: any, i: number) => (
    <Label key={i}>
      {i + 1 == current_answer ? (
        <Input
          type="radio"
          name={node.id}
          checked={true}
          value={i + 1}
          onChange={(e) => {
            setAnswerData(node.id, e.target.value);
          }}
        />
      ) : (
        <Input
          type="radio"
          name={node.id}
          value={i + 1}
          onChange={(e) => {
            setAnswerData(node.id, e.target.value);
          }}
        />
      )}
      {i + 1}: {a}
    </Label>
  ));
  return <Col className="ema__flex_clm">{InputRadio}</Col>;
};

export default QuetionRadio;
